import { render } from "./ExpiredScreen.vue?vue&type=template&id=147b33da&scoped=true&ts=true"
import script from "./ExpiredScreen.vue?vue&type=script&lang=ts"
export * from "./ExpiredScreen.vue?vue&type=script&lang=ts"

import "./ExpiredScreen.vue?vue&type=style&index=0&id=147b33da&scoped=true&lang=css"

import exportComponent from "/home/runner/work/owt/owt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147b33da"]])

export default __exports__